module.exports = __webpack_public_path__ + "img/18.17fb59f8.jpg";